import { useRouteContext } from '@tanstack/react-router';
import { useMemo } from 'react';

/**
 * Optimized hook to access portal context with memoization.
 *
 * This hook reduces unnecessary object cloning and re-renders by memoizing
 * the context values. Use this instead of useRouteContext({ from: '__root__' })
 * throughout the application.
 *
 * @returns Portal context with portalId, locale, baseUrl, and isInIframe
 */
export function usePortalContext() {
	const context = useRouteContext({ from: '__root__' });

	// Memoize to prevent unnecessary re-renders and reduce object cloning overhead
	return useMemo(
		() => ({
			portalId: context.portalId,
			locale: context.locale,
			baseUrl: context.baseUrl,
			isInIframe: context.isInIframe,
		}),
		[context.portalId, context.locale, context.baseUrl, context.isInIframe],
	);
}
